// Stops a sign-in redirect loop (for example the backend rejecting every Keycloak token):
// more than SIGN_IN_REDIRECT_LIMIT redirects inside the window blocks further automatic redirects.
export const SIGN_IN_REDIRECT_LIMIT = 3;
export const SIGN_IN_REDIRECT_WINDOW_MS = 60000;

export function createSignInRedirectGuard({ storage, now = () => Date.now(), key = 'mitus.signInRedirects', limit = SIGN_IN_REDIRECT_LIMIT, windowMs = SIGN_IN_REDIRECT_WINDOW_MS }) {
  function read() {
    try {
      const value = JSON.parse(storage.getItem(key) || '[]');
      return Array.isArray(value) ? value.filter(Number.isFinite) : [];
    } catch {
      return [];
    }
  }
  return {
    tryRecord() {
      const time = now();
      const recent = read().filter(attempt => time - attempt < windowMs);
      if (recent.length >= limit) return false;
      recent.push(time);
      try { storage.setItem(key, JSON.stringify(recent)); } catch { /* storage unavailable: never block sign-in */ }
      return true;
    },
    reset() {
      try { storage.removeItem(key); } catch { /* storage unavailable */ }
    },
  };
}
